export default "__VITE_ASSET__B9ToX$yb__"